const tableData = {
  columns: [

    { name: "Customer_Name", align: "center" },
    { name: "Primary_Key", align: "center" },
    { name: "Facility", align: "center" },
    { name: "State", align: "center" },

  ]
};

export default tableData;